import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  AmazonStaffPeerLetter,
  AmazonStaffAdminLetter,
} from '../'
import Styles from './AmazonStaffLetters.css'

@CSSModules(Styles,{allowMultiple:true})
export default class AmazonStaffLetters extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    //
    return (
      <div>
        <AmazonStaffAdminLetter />
        <AmazonStaffPeerLetter />
      </div>
    )
  }
}